import {Select as AntdSelect} from "antd";

const {Option} = AntdSelect;

const Select = ({
                    label = "",
                    name,
                    placeholder,
                    disabled,
                    onSearch,
                    filterOption,
                    onChange,
                    value,
                    labelInValue,
                    options = [],
                    className,
                    mode,
                    maxCount,
                }) => {
    return (<div>
            <AntdSelect
                className={className}
                label={label}
                placeholder={placeholder}
                showSearch
                onSearch={onSearch}
                labelInValue={labelInValue}
                value={value}
                name={name}
                onChange={onChange}
                filterOption={filterOption}
                disabled={disabled}
                mode={mode}
                maxCount={maxCount}
                allowClear
            >
                {options.map((option) => (<Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>))}
            </AntdSelect>
        </div>);
};

export default Select;
